<template>
  <div class="pane-box">

    <div class="pane-label">
      <div></div>{{label}}
    </div>

  </div>
</template>
<script>
  export default {
    props: {
      label: {
        type: String,
        default: "标签"
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  @import "../../assets/style/mixin";

  .pane-box {
    // width: 100%;
    margin-top: 10px;
  }

  .pane-label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 32px;

    div {
      width: 5px;
      height: 14px;
      border-radius: 2px;
      background-color: #00a5d5;
      margin-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?011a8014